import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1A3626] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-4 mb-4">
              <img 
                src="/logo-new.png" 
                alt="Krishna Machinery Stores" 
                className="h-16 w-auto object-contain"
              />
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif', letterSpacing: '0.02em' }}>
                  KRISHNA
                </span>
                <span className="text-sm text-white/90 tracking-widest" style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15em' }}>
                  MACHINERY STORES
                </span>
              </div>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              Your trusted partner for agricultural & industrial machinery solutions. Serving farming and industrial communities with quality equipment and dedication.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#C05A3E] flex-shrink-0 mt-0.5" />
                <p className="text-sm text-white/80">
                  C.P.Towers, near Apurvam Plywood,<br />
                  Malegaon Motor Stand, Panchavati,<br />
                  Nashik - 422003
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#C05A3E] flex-shrink-0" />
                <div className="text-sm text-white/80">
                  <a href="tel:9607515786" className="hover:text-white">9607515786</a>
                  {' | '}
                  <a href="tel:02532515786" className="hover:text-white">0253-2515786</a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#C05A3E] flex-shrink-0" />
                <a href="mailto:krishnamachinerystores2@gmail.com" className="text-sm text-white/80 hover:text-white break-all">
                  krishnamachinerystores2@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links & Hours */}
          <div>
            <h3 className="font-bold text-lg mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>Quick Links</h3>
            <div className="space-y-2 mb-6">
              <Link to="/" className="block text-sm text-white/80 hover:text-white transition-colors">Home</Link>
              <Link to="/about" className="block text-sm text-white/80 hover:text-white transition-colors">About Us</Link>
              <Link to="/cart" className="block text-sm text-white/80 hover:text-white transition-colors">Cart</Link>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="h-5 w-5 text-[#C05A3E] flex-shrink-0 mt-0.5" />
              <div className="text-sm text-white/80">
                <p className="font-medium text-white mb-1">Business Hours</p>
                <p>Mon - Sat: 10:00 AM - 8:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-6 text-center">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Krishna Machinery Stores. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;